import './_login.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('login', {
    url: '/login',
    views: {
      '@': {
        template: require('./login-route.template.html'),
        controller: function(session, $scope) {
          this.session = session;
        },
        controllerAs: '$ctrl'
      }
    },
    resolve: {
      $title: function() {
        return 'Sign in to Ink Finder';
      },
      session: function(Session) {
        return Session;
      }
    }
  });
});



// WEBPACK FOOTER //
// ./routes/login/index.js